import { TDealRentVersionState } from './types';

export const defaultState: TDealRentVersionState = null;

export function dealRentVersion(state: TDealRentVersionState): TDealRentVersionState {
  return state ?? defaultState;
}
